<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <div class="cart-empty" :class="{ '_center-text': !isBasket }">
    <div class="cart-empty__container">
      <div class="cart-empty__pic">
        <cart-bag
          class="cart-empty__icon"
          width="160"
          height="160"
        />
      </div>
      <div class="cart-empty__body">
        <template>
          <h2 class="cart-empty__title">
            Ваша корзина сейчас пуста
          </h2>
          <p class="cart-empty__text">
            Воспользуйтесь нашим каталогом, чтобы ее заполнить.<br />У нас всегда есть, что почитать!
          </p>
          <div class="cart-empty__button">
            <a :href="linkToCatalog" class="b24-btn _block">
              Перейти в каталог
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import { mainStore } from 'partners-widget-core';
import { WISH_LIST_TAB_VALUE } from '@/enums';

import useAuthorizations from '@/compositions/user/useAuthorizations';

import CartBag from '@/assets/sprite/svg/cart-bag.svg';
import BookMark24 from '@/assets/sprite/svg/24/Add_bookmark_24.svg';

export default defineComponent({
  name: 'EmptyBasket',
  components: {
    CartBag,
    BookMark24,
  },
  props: {
    isBasket: { type: Boolean, default: true },
    isEmptyWishList: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const { isAuthorized } = useAuthorizations();

    const handlerClickWishList = () => {
      emit('changeTab', WISH_LIST_TAB_VALUE);
    };

    const handlerClickAuth = () => {
      emit('openAuthModal');
    };

    return {
      linkToCatalog: mainStore.store.env.linkToCatalog,
      isAuthorized,
      handlerClickWishList,
      handlerClickAuth,
    };
  },
});
</script>

<style lang="less">
.cart-empty {
  &__container {
    padding-top: @size-x8;
    padding-bottom: @size-x10;
  }

  &__pic {
    display: flex;
    justify-content: center;
    margin-bottom: @size-x6;
  }

  &__title {
    .h-reset();
    .h3-desktop();

    margin-bottom: @size-x2;
    text-align: center;
  }

  &__text {
    .p();

    margin: 0 0 @size-x6;
    text-align: center;
  }

  &__link {
    text-decoration: none;
  }

  &__button {
    width: 240px;
    margin: 0 auto;
  }

  &__btn-text {
    .a-reset();
    .button-reset();
    .p();

    color: @link;
    transition: color @A;
    font-weight: 600;

    &:hover,
    &._tap {
      color: @link-hover;
    }
  }

  &._center-text &__container {
    align-items: center;
  }

  &._center-text &__text {
    padding-top: 0;
  }

  &__example-icon {
    width: 24px;
    height: 24px;
    fill: @gray-dark;
    display: block;
    margin: @size-x2 auto;
  }
}
</style>
